export function isPartOfDocumentLayout(element: Element): boolean {
  const box = element.getBoundingClientRect();

  // based on the check performed by MUI's `Slide` component
  //   https://github.com/mui/material-ui/blob/7aa3fab10217d0a4c4ac2bd82d0ef5b80d6b18e9/packages/mui-material/src/Slide/Slide.js#L298
  return !(box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0);
}
